module.exports = __webpack_public_path__ + "img/img-15.948c7a83.webp";